
import Assistant from "./Assistant";

const assistantRoutes = [
    {
        path: "assistant",
        element: <Assistant />,
    },
];

export default assistantRoutes;
